import { DropdownTheme, Dropdown as TPADropdown } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef } from 'react';
import { useConfig } from '../../../contexts/config-context';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
import { useTranslation } from '../../../sdk/components';
import { getMonthList } from './helpers';
import { classes } from './month-select-wut.st.css';
export function MonthSelectWUT(props) {
    const { id, className, onChange, ...rest } = props;
    const { t } = useTranslation();
    const { isMobile, language } = useConfig();
    const dropdown = useRef(null);
    const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
    // The `key` below flips the first time a value is picked (empty -> value),
    // which remounts the dropdown and destroys the focused trigger, dropping focus
    // to <body> so the next Tab restarts from the top of the page. Re-focus after
    // that remount, but only for a user selection (guarded by the ref) so we never
    // steal focus on an external value change.
    const shouldRefocusRef = useRef(false);
    useEffect(()=>{
        if (shouldRefocusRef.current) {
            shouldRefocusRef.current = false;
            dropdown.current?.focus();
        }
    }, [
        props.value
    ]);
    const options = useMemo(()=>getMonthList(language).map((month, index)=>({
                value: month,
                id: `${index + 1}`,
                isSelectable: true
            })), [
        language
    ]);
    return /*#__PURE__*/ React.createElement(TPADropdown, {
        ...rest,
        key: String(Boolean(props.value)),
        upgrade: true,
        ref: dropdown,
        newErrorMessage: true,
        mobileNativeSelect: isMobile,
        "aria-label": t('field.date.placeholder.month'),
        options: options,
        onChange: handleChange,
        initialSelectedId: props.value ? props.value.toString() : undefined,
        className: classNames(className, classes.root, classes.theme, {
            [classes.hover]: forcedHover,
            [classes.mobileDropdown]: isMobile
        }),
        theme: DropdownTheme.Box,
        flip: false
    });
    function handleChange(option) {
        // force focus to be within the "date field" so validation won't be triggered prematurely.
        // Only refocus on a real value change, so a stale flag can't later steal focus.
        shouldRefocusRef.current = option.id !== props.value;
        onChange?.(option.id);
        dropdown.current?.focus();
    }
}

//# sourceMappingURL=month-select-wut.js.map